<script lang="ts">
	import { createEventDispatcher } from 'svelte';

  export let addToCurationTextEnter = 'Enter';
  export let addToCurationTextPlaceholder = 'New Curation';

	const dispatch = createEventDispatcher();

	let value: string = '';

	function init(el: any) {
		el.focus();
	}

	function handleSubmit(e: any) {
		e.preventDefault();
		e.stopPropagation();

		dispatch('newCurationSubmit', {
			value
		});
		value = '';
	}
</script>

<form on:submit={handleSubmit} class="relative">
	<input
		class="border border-neutral-400 w-full p-1 px-3 rounded
        focus:outline-none focus:border-black
        pr-16 leading-[2]"
		type="text"
		bind:value
		use:init
		placeholder={addToCurationTextPlaceholder}
	/>
	<div
		class="absolute w-full h-full pointer-events-none flex justify-end items-center top-0 left-0 px-2"
	>
		<button
			type="submit"
			value={addToCurationTextEnter}
			disabled={!value.length}
			class="group flex gap-1 {value.length > 0
				? 'text-green-400 hover:text-white hover:bg-green-400'
				: 'text-neutral-550'} text-sm px-2 py-2 rounded pointer-events-auto transition-all"
		>
			Enter
		</button>
	</div>
</form>
